import { Link } from "react-router-dom";
const subMenu = ({ name, subLink, status }) => {
  let url = subLink;

  if (status !== "0") {
    url = `${subLink}/${status}`;
  }

  return (
    <li>
      <Link to={url}>
        <i className="fa fa-hand-o-right" /> {name}
      </Link>
    </li>
  );
};

export default subMenu;
